const NUTRITION_DIET_OPTIONS = [
  { id: 'vegan', label: 'Vegan', searchValues: ['Vegan'] },
  { id: 'vegetarian', label: 'Vegetarian', searchValues: ['Vegetarian'] },
  { id: 'pescetarian', label: 'Pescetarian', searchValues: ['Pescatarian', 'Pescetarian'] },
  { id: 'gluten-free', label: 'Gluten-free', searchValues: ['Gluten-free'] },
  { id: 'keto', label: 'Keto', searchValues: ['Keto'] },
  { id: 'low-fat', label: 'Low fat', searchValues: ['Low fat'] },
  { id: 'low-carb', label: 'Low carb', searchValues: ['Low carb'] },
  { id: 'low-calorie', label: 'Low calorie', searchValues: ['Low calorie'] },
];

export const NUTRITION_DIET_OPTION_IDS = NUTRITION_DIET_OPTIONS.map(option => option.id);

// An explicit answer to "do you have any dietary preferences?". Stored in the Prefer list so the
// user is not asked again, but it is not a diet: it never reaches search and is not an option above.
export const NUTRITION_DIET_NO_PREFERENCE_ID = 'no-preference';
export const NUTRITION_DIET_NO_PREFERENCE_LABEL = 'No dietary preference';

export const NUTRITION_DIET_EXCLUSIVE_GROUP = ['vegan', 'vegetarian', 'pescetarian'];

export const NUTRITION_DIET_OVERRIDES = {
  vegan: ['vegetarian', 'pescetarian'],
  vegetarian: ['pescetarian'],
};

export const getOverriddenDietIds = (ids = []) => {
  const overridden = new Set();
  ids.forEach(id => {
    (NUTRITION_DIET_OVERRIDES[id] || []).forEach(overriddenId => overridden.add(overriddenId));
  });
  return overridden;
};

// "No preference" only stands on its own: any real diet alongside it wins.
export const normalizeDietSelection = (ids = []) => {
  const overridden = getOverriddenDietIds(ids);
  const hasDiet = ids.some(id => id !== NUTRITION_DIET_NO_PREFERENCE_ID);
  return ids.filter(
    id => !overridden.has(id) && !(hasDiet && id === NUTRITION_DIET_NO_PREFERENCE_ID),
  );
};

export const getNutritionDietSearchValues = ids =>
  normalizeDietSelection(ids)
    .map(id => NUTRITION_DIET_OPTIONS.find(option => option.id === id))
    .filter(Boolean)
    .flatMap(option => option.searchValues);

// One value per id — the canonical spelling used by the ES index (and shown in
// the diet dropdown). Used when we need to surface the Limit through the same
// URL parameter the dropdown reads from.
export const getPrimaryNutritionDietSearchValues = ids =>
  normalizeDietSelection(ids)
    .map(id => NUTRITION_DIET_OPTIONS.find(option => option.id === id))
    .filter(Boolean)
    .map(option => option.searchValues[0]);

export default NUTRITION_DIET_OPTIONS;
